import { render, staticRenderFns } from "./_base-icon.vue?vue&type=template&id=226c0f86&"
import script from "./_base-icon.vue?vue&type=script&lang=js&"
export * from "./_base-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('226c0f86')) {
      api.createRecord('226c0f86', component.options)
    } else {
      api.reload('226c0f86', component.options)
    }
    module.hot.accept("./_base-icon.vue?vue&type=template&id=226c0f86&", function () {
      api.rerender('226c0f86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base-icon.vue"
export default component.exports